import React, { useEffect } from 'react'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import { colors } from '@resiliatech/birdsong'
import { IntakeFlowStep } from '../../constants'
import {
  LoadingImpactPlanContainer,
  WandCircle,
  Description,
  PulsingCircle,
  WandWrapper,
} from './LoadingImpactPlan.styled'

type Props = {
  onNextStep: (nextStep: IntakeFlowStep) => void
}

export const LoadingImpactPlan = ({ onNextStep }: Props) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onNextStep(IntakeFlowStep.IMPACT_PLAN)
    }, 5000)

    return () => clearTimeout(timer)
  }, [onNextStep])

  return (
    <LoadingImpactPlanContainer>
      <WandWrapper>
        <PulsingCircle />
        <WandCircle>
          <AutoFixHighIcon
            style={{ fontSize: '34px' }}
            sx={{ color: colors.interactive.primaryEnabled }}
          />
        </WandCircle>
      </WandWrapper>
      <Description>
        We&apos;re building an impact plan based on your organization&apos;s
        unique profile, your confidence levels, and similar nonprofits in your
        impact area.
      </Description>
    </LoadingImpactPlanContainer>
  )
}
